import { useContext, useEffect } from 'react';
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';

import { AuthApi } from '@/API/authApi/AuthAPI';
import { AuthContext } from '@/context/AuthContext';
import { useAuthTokens } from '@/hooks/useAuthTokens/useAuthTokens';

const SsoLogics = () => {
	const { isAuth, setIsAuth } = useContext(AuthContext);
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const { refreshTokens } = useAuthTokens();

	const handleSsoCallback = async (code: string, state: string) => {
		try {
			const res = await AuthApi.ssoLogin(code, state);
			if ('status' in res && res.status && res.status === 200) {
				localStorage.setItem('accessToken', res.data.access);
				localStorage.setItem('refreshToken', res.data.refresh);
				refreshTokens();

				if (setIsAuth) {
					setIsAuth(true);
				}

				navigate('/', { replace: true });
			} else {
				navigate('/error', {
					replace: true,
					state: {
						code: 'status' in res ? res.status : '500',
						message: 'Не удалось войти через SSO',
					},
				});
				return;
			}
		} catch (error: unknown) {
			console.error('Ошибка при обработке SSO callback:', error);
		}
	};

	useEffect(() => {
		const code = searchParams.get('code');
		const state = searchParams.get('state');

		if (!code || !state) {
			navigate('/error', {
				replace: true,
				state: {
					code: '400',
					message: 'Не удалось обработать SSO callback',
				},
			});
			return;
		}

		handleSsoCallback(code, state);
	}, [navigate, searchParams]);

	if (isAuth) {
		return <Navigate to='/' replace={true} />;
	}

	return null;
};

export default SsoLogics;
